module.exports = __webpack_public_path__ + "img/7c.15d67da7.png";